import { AdminStore } from 'types';
import { projects } from './projects';
import { companies } from './companies';
import { tokensRequests } from './tokens-requests';
import { users } from './users';
import { communities } from './communities';

export const admin: AdminStore = {
  projects,
  communities,
  companies,
  tokensRequests,
  users,
};
